import { render, staticRenderFns } from "./ViewServiceType.vue?vue&type=template&id=61e8c58a"
import script from "./ViewServiceType.vue?vue&type=script&lang=js"
export * from "./ViewServiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports